import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';


import { LicitacaoService } from '../../../../providers/licitacao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";
import { ModalPreVisualizarLicitacaoPage } from '../../../modais/modal-pre-visualizacao/licitacao/modal-pv-licitacao';

@Component({
  selector: 'page-resumo-analise',
  templateUrl: 'resumo-analise.html',
  providers: [
    LicitacaoService
  ]
})
export class LicitacaoResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  loading: boolean = true;


  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public licitacaoService: LicitacaoService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(7);

    console.log("valor isJurisdicionado" + this.isJurisdicionado);
  }

  carregarDados() {
    if (!this.isJurisdicionado) {
      this.licitacaoService.obterListaAnalises(this.licitacaoService.codigoModuloLicitacao).subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    } else {
      this.licitacaoService.obterListaAnalisesJur(this.licitacaoService.codigoModuloLicitacao).subscribe(data => {
        this.listaAnalises = data;
        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
  }

  redirecionarParaAnalise(analise) {
    analise.cdModulo = this.licitacaoService.obterIdPaginaLicitacao();
    this.menuService.redirecionarSubPagina(this.licitacaoService.obterIdPaginaLicitacao(), analise);
  }

  previsualizarCertificado() {
    let modal = this.modalCtrl.create(ModalPreVisualizarLicitacaoPage, {});
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
      }
    });
    modal.present();
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  obterDescricao (desc) {
    if (!this.isJurisdicionado){
      return desc;
    } 
    var novaDesc = "";
    if (desc == "Análise não realizada"){
      novaDesc = "Não preenchido pelo jurisdicionado"
    }

    return novaDesc;
  };

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 7).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'LICITACAO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'LICITACAO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/licitacao/resumo-analise/resumo-analise.ts